import { CustomButton } from "@/components/common/customButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import type { TermSheetDialogState } from "./pipelineCellSave";

type PipelineTermSheetDialogProps = {
  dialog: TermSheetDialogState;
  onClose: () => void;
};

export function PipelineTermSheetDialog({
  dialog,
  onClose,
}: PipelineTermSheetDialogProps) {
  return (
    <Dialog open={dialog.open} onClose={onClose}>
      <DialogTitle>Status not changed</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The status was not saved. These deals cannot move to Term Sheet
          Submitted until the required fields are filled in:
        </DialogContentText>
        {dialog.rows.map((row) => (
          <DialogContentText key={row.id} sx={{ mt: 1.5 }}>
            <strong>{row.dealName}</strong>
            {" — missing: "}
            {row.missingFields.join(", ")}
          </DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <CustomButton
          handleButtonPress={onClose}
          isButtonDisabled={false}
          text="Close"
          solid={false}
        />
      </DialogActions>
    </Dialog>
  );
}
